var map = {
	"./it_transformation.jpg": 6752,
	"./it_transformation.svg": 3796,
	"./spekter.jpg": 7172,
	"./trafficJet.jpg": 1072,
	"./yeDuCoders.jpg": 1700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1768;